import React, { useState } from 'react';
import { connect } from 'react-redux';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import RoleTools from './RoleTools';

const RoleToolsMenu = ({
  allowRead,
  category,
  role,
  listItem = false,
  upward,
  url,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <StandardToolsMenu
      allowRead={allowRead}
      href={url}
      listItem={listItem}
      onChange={setOpen}
      open={open}
      upward={upward}
    >
      {open && (<RoleTools category={category} role={role} />)}
    </StandardToolsMenu>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { roles: { read } } } },
}) => (
  { allowRead: read }
);

export default connect(mapStateToProps)(RoleToolsMenu);
